import { FileFormatEnum } from '@epi-models/pages/Beneficiaries';

export const getTemplateUrl = (
  language: 'en' | 'fi',
  format: FileFormatEnum
) => {
  return `https://efidocsstorep.blob.core.windows.net/documents/emp/${language}-userimporttemplate.${format}`;
};
